export default "__VITE_ASSET__aeiag_7o__"